import React from 'react'
import { Conditional, ShowIf } from '@mc/conditional-rendering'
import { useFreeTrial, FreeTrialPricingFeature } from '@mc/free-trial'
import { usePlansContext } from '@mc/plans-ui'
import { usePromotion } from '@mc/promo-utils'
import { PromoPricingFeature } from '@mc/promos'
import {
  IntroPricingPricingFeature,
  useIntroPricingUpgradeExperiment,
} from '../../../../experiments/prcng-338_v1_intro_pricing'
import { DefaultPricingFeature } from './components/DefaultPricingFeature'

export const PricingFeature = () => {
  const { isGift } = usePlansContext()
  const { trial } = useFreeTrial({ isGift })
  const { isPromotionOn } = usePromotion({
    isGift,
  })
  const { isIntroPricingPrePurchase } = useIntroPricingUpgradeExperiment()

  return (
    <Conditional>
      <ShowIf condition={trial.eligible}>
        <FreeTrialPricingFeature />
      </ShowIf>
      <ShowIf condition={isPromotionOn}>
        <PromoPricingFeature />
      </ShowIf>
      <ShowIf condition={isIntroPricingPrePurchase}>
        <IntroPricingPricingFeature />
      </ShowIf>
      <ShowIf isDefault>
        <DefaultPricingFeature />
      </ShowIf>
    </Conditional>
  )
}
